<script>
const $ = window.$;

export default {
  name: 'HeaderONF',
  mounted() {
    $(document).on("ifw_muteSound", this.mute.bind(this));
    $(document).on("ifw_unmuteSound", this.unmute.bind(this));
  },
  methods: {
    mute() {
      this.$store.dispatch('Sound/MUTE', true);
    },
    unmute() {
      this.$store.dispatch('Sound/MUTE', false);
    }
  }
}
</script>

<template>
  <header id="header"></header>  
</template>

<style scoped lang="scss">
#header{
  position: relative;
  width: 100%;
  height: 46px;
  color: $c-white;
  background-color: $c-black;
  z-index: $z-index-header;
  opacity: 0;
  @include flexbox(center-vertical);
}
</style>
